if (typeof $ == 'undefined') {
    var $ = jQuery;
    window.$ = $;
}

import banner from './modules/banner';
import menu from './modules/menu';
import sidebar from './modules/sidebar';
import filter from './modules/filter';
import productList from './modules/productList';
import productParent from './modules/productParent';
import dealers from './modules/dealers';
import quickOrder from './modules/quickOrder';
import brandLinks from './modules/brandLinks';
import wr360 from './modules/wr360';
import search from './modules/search';

var js_routes = {
    'common': [
        menu,
        banner,
        wr360,
        search
    ],
    'product-list': [
        sidebar,
        filter,
        productList
    ],
    'product-parent': [
        productParent
    ],
    'dealers': [
        sidebar,
        filter,
        dealers
    ],
    'quick-order': [
        filter,
        quickOrder
    ],
    'page': [
        brandLinks
    ],
    'downloads': [
        sidebar,
        filter,
        productList
    ],
    'news-archive': [
        sidebar,
        filter,
        productList
    ]
};

$(function() {
    $.each($('body').data('jsroute'), function(i, route) {
        if (route) {
            $.each(js_routes[route], function(j, method) {
                js_routes[route][j]();
            });
        }
    });
});
